<div class=" banner_header">
  <div class="col-md-12">
      <h2>Exam Center List</h2>
  </div>
</div>

<!--Content Start-->
<section class="section_box_one">
  <div class="container">

      <table>
        <tr>
          <th>Name of Examination centre </th>
          <th> Examination centre code </th>
        </tr>

        <tr>
          <td>CFI0900001-National Skill Training Insitute(Women), Noida</td>
          <td>CFI0900001</td>
        </tr>
      </table>
  </div>
</section>
<!--Content End-->





<style>
  .section_box_one {
      padding: 30px 0px;
  }

  .section_box_one h2 {
      border-bottom: 5px solid #000;
      padding-bottom: 5px;
      width: fit-content;
      margin: 0 auto 30px;
  }

  .banner_header {
      background: #2955a9;
      padding: 10px 0px;
      text-align: left;
      color: #fff;
      margin: 0px;
  }

  .banner_header h2 {
      font-size: 21px;
  }

  .download_section {
      padding: 40px 0px;
      text-align: center;
  }

  .steps {
      left: 0px;
      height: 50px;
      width: 50px;
      background-color: #29ab55;
      border-radius: 50%;
      display: inline-block;
      font-size: 31px;
      text-align: center;
      color: #fff;
      position: absolute;
  }

  .step_cls {
      padding: 0px 70px 0px;
  }

  .click_here {
      background: #2955a9;
      padding: 5px 15px;
      color: #fff;
      font-size: 21px;
      font-weight: 500;
      border-radius: 10px;
      width: fit-content;
      cursor: pointer;
  }

  .click_here:hover {
      background-color: #000;
  }

  .payment_cls {
      padding: 30px 0px 120px;
  }
</style>
